export class mdlCheckUrlRes {
    public StatusCode: string;
    public LinkResult: string;
    public ErrorMsg: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckUrlRes.ts